// First-turn welcome bubble shown in the chat panel before the user sends
// any messages. Splits into two cases:
//
//   1. The session-create response carried a `welcomeMessage` — the API
//      computed a config-aware greeting (inheritance summary or "in
//      progress" line) on the server, so render that as-is.
//   2. No server-provided text — fall back to a generic greeting. This
//      happens for unsupported phases, missing tenant context, or when the
//      config service throws on the API side.

export interface WelcomeBubbleMessage {
  id: string;
  role: 'assistant';
  content: string;
  createdAt: string;
}

export const FALLBACK_WELCOME_TEXT =
  "Welcome! I'm here to help you with this project phase. What would you like to work on?";

export function buildWelcomeBubble(welcomeText: string | undefined | null): WelcomeBubbleMessage {
  const content = welcomeText && welcomeText.trim().length > 0 ? welcomeText : FALLBACK_WELCOME_TEXT;
  return {
    id: '__welcome__',
    role: 'assistant',
    content,
    createdAt: new Date().toISOString(),
  };
}
